// extracted by mini-css-extract-plugin
export default {"emptyFooter":"Account_emptyFooter__bF2sx"};